import React from 'react';

// TUHI AI's face. Every surface that shows TUHI uses this one component so
// the persona never drifts back to an emoji. The 96 px asset serves small
// chips, the 256 px asset anything larger (and retina chips).
export const TUHI_AVATAR_SRC = {
  small: '/tuhi-avatar-96.webp',
  large: '/tuhi-avatar-256.webp',
};

export default function TuhiAvatar({ size = 24, pulse = false, className = '', title = 'TUHI AI' }) {
  const src = size > 40 ? TUHI_AVATAR_SRC.large : TUHI_AVATAR_SRC.small;
  return (
    <img
      src={src}
      srcSet={`${TUHI_AVATAR_SRC.small} 96w, ${TUHI_AVATAR_SRC.large} 256w`}
      sizes={`${size}px`}
      width={size}
      height={size}
      alt={title}
      title={title}
      loading="lazy"
      decoding="async"
      className={`inline-block rounded-full object-cover shrink-0 ring-1 ring-cv-orange/30 ${pulse ? 'animate-pulse' : ''} ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
